import React from 'react';
import { WebsiteDesignProps } from './types';
import { SprayCan, Zap, Music, ArrowRight } from 'lucide-react';
import { Button } from "@/components/ui/button";

const UrbanStreet: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Metro City High";

    return (
        <div className="bg-[#111] text-white min-h-screen font-sans selection:bg-yellow-400 selection:text-black">
            {/* Texture */}
            <div className="fixed inset-0 pointer-events-none opacity-10 z-0 bg-no-repeat bg-cover" style={{backgroundImage: 'url(https://www.transparenttextures.com/patterns/concrete-wall.png)'}}></div>

            <nav className="relative z-20 p-6 flex justify-between items-center bg-black border-b border-gray-800">
                <div className="text-3xl font-black uppercase tracking-tighter italic text-yellow-400 -rotate-2">
                    {schoolName}
                </div>
                <div className="flex gap-4">
                    <Button className="bg-white text-black font-black uppercase hover:bg-yellow-400 border-2 border-transparent hover:border-white transition-all transform hover:-translate-y-1">
                        Portal
                    </Button>
                </div>
            </nav>

            <main className="relative z-10 w-full overflow-hidden">
                <section className="py-20 px-6 container mx-auto">
                    <div className="relative">
                        {/* Graffiti effect */}
                        <div className="absolute -top-10 -left-10 text-[10rem] md:text-[15rem] font-black text-gray-800 opacity-20 select-none">
                            CREATE
                        </div>
                        
                        <div className="relative z-10 flex flex-col items-start gap-8">
                            <h1 className="text-7xl md:text-9xl font-black uppercase leading-[0.85] tracking-tight">
                                Make Your <br/> <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-red-500 to-pink-500">Mark.</span>
                            </h1>
                            <p className="text-xl md:text-2xl font-bold bg-white text-black p-4 rotate-1 max-w-lg shadow-[8px_8px_0px_#facc15]">
                                Education for the hustlers, the creators, and the game changers. We don't follow rules, we make them.
                            </p>
                            <Button className="h-20 px-12 text-2xl font-black uppercase bg-[#facc15] text-black hover:bg-white rounded-none border-4 border-black shadow-[8px_8px_0px_white] hover:shadow-[4px_4px_0px_white] hover:translate-x-1 hover:translate-y-1 transition-all">
                                Join The Crew <ArrowRight className="ml-2 w-8 h-8" />
                            </Button>
                        </div>
                    </div>
                </section>

                <div className="border-y-4 border-white bg-yellow-400 text-black py-4 overflow-hidden mt-12 rotate-[-2deg] scale-105">
                     <div className="animate-marquee whitespace-nowrap font-black text-4xl uppercase flex gap-12">
                         <span>Art • Music • Code • Design • Film • Streetwear •</span>
                         <span>Art • Music • Code • Design • Film • Streetwear •</span>
                         <span>Art • Music • Code • Design • Film • Streetwear •</span>
                     </div>
                </div>

                <section className="py-24 px-6 container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
                    {[
                        { icon: SprayCan, color: "bg-pink-500", title: "Visual Arts", desc: "From canvas to concrete." },
                        { icon: Music, color: "bg-blue-500", title: "Sound Design", desc: "Beats, production, and audio engineering." },
                        { icon: Zap, color: "bg-green-500", title: "Tech Lab", desc: "Coding the future of the streets." },
                    ].map((item, i) => (
                        <div key={i} className="bg-[#222] border-2 border-gray-700 p-8 hover:border-white transition-colors group">
                            <div className={`w-16 h-16 ${item.color} flex items-center justify-center border-4 border-black shadow-[4px_4px_0px_white] mb-6 group-hover:-translate-y-2 transition-transform`}>
                                <item.icon size={32} className="text-black" />
                            </div>
                            <h3 className="text-3xl font-black uppercase mb-2 italic">{item.title}</h3>
                            <p className="text-gray-400 font-bold">{item.desc}</p>
                        </div>
                    ))}
                </section>
            </main>
        </div>
    );
};

export default UrbanStreet;
